<template>
  <div>
    <router-link to="/" id="home-link"></router-link>
    <router-link to="/about" id="about-link"></router-link>
    <router-link to="/login" id="login-link"></router-link>
    <router-link to="/settings" id="settings-link"></router-link>
    <router-link to="/chat" id="chat-link"></router-link>
  </div>
</template>

<script>
export default {
  name: "WNavLinks",
};
</script>

<style lang="scss" scoped>
a {
  display: none;
}
</style>
